module.exports = __webpack_public_path__ + "static/img/footOneImg3.42a3a23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footOneImg3.png
// module id = QtZt
// module chunks = 1